import React from 'react';
import ItemLabel from '../../../components/ItemLabel/ItemLabel';
import { commonConstants } from '../../constants';

const OrderTypeText = ({ orderType, orderStatus, deliveredOn, deliverBy, pickedUpOn, pickupBy, servicedOn, serviceBy, mixOrderConfiguration, scheduledForStart, scheduledForEnd }) => {
  const renderDateText = (label, date) => <ItemLabel label={label} text={date} />;

  const isNotDefaultDate = (date) => date && date !== commonConstants.defaultDateTime;

  const formatScheduledTime = (start, end) => {
    if (!start || !end) return null;
    const formatDateTime = (dateTime, includeDate = true) => {
      if (!dateTime) return "";
      const [date, time, meridian] = dateTime.replace(/[()]/g, "").split(" ");
      const formattedTime = `${time.split(":").slice(0, 2).join(":")} ${meridian}`;
      return includeDate ? `${date} (${formattedTime})` : formattedTime;
    };
    const [startDate] = start.replace(/[()]/g, "").split(" ");
    const [endDate] = end.replace(/[()]/g, "").split(" ");
    if (startDate === endDate) {
      return `${startDate} (${formatDateTime(start, false)} - ${formatDateTime(end, false)})`;
    }
    return `${formatDateTime(start)} - ${formatDateTime(end)}`;
  };

  const renderDeliveryText = () => {
    const isMixOrder = mixOrderConfiguration == "D";
    if ((orderStatus === "Delivered" || orderStatus === "Complete") && isNotDefaultDate(deliveredOn)) {
      return renderDateText(isMixOrder ? "Delivered on:" : "Completed on:", deliveredOn);
    } else if (scheduledForStart && scheduledForEnd) {
      const formattedSchedule = formatScheduledTime(scheduledForStart, scheduledForEnd);
      return renderDateText(isMixOrder ? "Scheduled For:" : "Complete by:", formattedSchedule);
    }
    return null;
  };

  const renderPickupText = () => {
    const isMixOrder = mixOrderConfiguration == "P";
    if ((orderStatus === "Picked Up" || orderStatus === "Complete") && isNotDefaultDate(pickedUpOn)) {
      return renderDateText(isMixOrder ? "Picked up on:" :  "Completed on:", pickedUpOn);
    } else if (isNotDefaultDate(pickupBy)) {
      return renderDateText(isMixOrder ? "Pickup by:" : "Complete by:", pickupBy);
    }
    return null;
  };

  const renderServiceRequestText = () => {
    const isMixOrder = mixOrderConfiguration == "SR";
    if (orderStatus === "Delivered" && isNotDefaultDate(servicedOn)) {
      return renderDateText(isMixOrder ? "Serviced on:" : "Completed on:", servicedOn);
    } else if (scheduledForStart && scheduledForEnd) {
      const formattedSchedule = formatScheduledTime(scheduledForStart, scheduledForEnd);
      return renderDateText(isMixOrder ? "Scheduled For:" : "Complete by:", formattedSchedule);
    }
    return null;
  };

  const renderServiceText = () => {
    const isMixOrder = mixOrderConfiguration == "SR";
    if (["Serviced", "Complete", "Delivered"].includes(orderStatus) && isNotDefaultDate(servicedOn)) {
      return renderDateText(isMixOrder ? "Serviced on:" : "Completed on:", servicedOn);
    } else if (scheduledForStart && scheduledForEnd) {
      const formattedSchedule = formatScheduledTime(scheduledForStart, scheduledForEnd);
      return renderDateText(isMixOrder ? "Scheduled For:" : "Complete by:", formattedSchedule);
    }
    return null;
  };

  if (orderStatus === "Canceled") return null;

  switch (orderType) {
    case "Delivery":
    case "Supplies":
    case "Supply":
      return renderDeliveryText();
    case "Pick Up":
    case "Pickup":
      return renderPickupText();
    case "Pick up all":
    case "Pickup all":
      return isNotDefaultDate(pickupBy) ? renderDateText("Pickup by:", pickupBy) : null;
    case "Service Request":
      return renderServiceRequestText();
    case "Service":
      return renderServiceText();
    default:
      return null;
  }
};

export default OrderTypeText;
